import PropTypes from 'prop-types';
import OrderItem from './axisOrderItem';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} AxisOrder
 * @prop {number} id Order id
 * @prop {number} displayId Order display id
 * @prop {string} guid Order guid
 * @prop {string} title Order title
 * @prop {string} project Order project
 * @prop {string} organization Order organization
 * @prop {string} createdDate Date order was created
 * @prop {string} deadline Deadline for the order
 * @prop {string} workflowState Current workflow state of the order
 * @prop {string} originator Originator of the order
 * @prop {string} submitter Order submitter
 * @prop {string} assignedTo Person the order is assigned to
 * @prop {string} approvalRequest Whether approval for the order was requested
 * @prop {string} id Order priority
 * @prop {Array} items List of items on the order
 */
export default PropTypes.shape({
  id: PropTypes.number,
  displayId: PropTypes.number,
  guid: PropTypes.string,
  title: PropTypes.string,
  project: PropTypes.string,
  organization: PropTypes.string,
  createdDate: PropTypes.string,
  deadline: PropTypes.string,
  workflowState: PropTypes.string,
  originator: PropTypes.string,
  submitter: PropTypes.string,
  assigntedTo: PropTypes.string,
  approvalRequested: PropTypes.bool,
  priority: PropTypes.string,
  expanded: PropTypes.boolean,
  url: PropTypes.string,
  items: PropTypes.arrayOf(OrderItem)
});



// WEBPACK FOOTER //
// ./app/propTypes/axisOrder.js